import React, { useMemo, useEffect } from "react";
import PropTypes from "prop-types";
import { Trackable } from "@dpdgroupuk/react-event-tracker";
import Header from "components/Header";
import Banner from "components/Banner";
import HexagonContent from "components/HexagonContent";
import VideoForceWatch from "./components/VideoForceWatch";
import TopContent from "../../components/TopContent";
import FloatingButton from "components/FloatingButton";
import driver4 from "assets/images/driver4.png";
import * as routes from "../../router/constants";

const CONNECT_DRIVER_CONTENT = {
  header: ["Connect", " delivery driver"],
  boldIndex: 0,
  list: [
    "Earn up to £18 per hour and get paid weekly",
    "Use your own vehicle",
    "Deliver close to you - you'll be making deliveries in your local area",
    "Easy to use app to manage your earnings",
  ],
};

const VIDEO_SECTIONS = {
  connect: {
    heading:
      "Watch our short film to see how easy it is to get started and start earning as a DPD Connect courier",
    action: false,
    videoUrl: "https://www.youtube.com/embed/KovDLD-RB6U",
    buttonText: "Apply Now",
    color: "tertiary",
    buttonLink: "https://dpd.recruitment.withwise.com/locations",
  },
};

export const ChooseConnect = ({ pageId, windowWidth, urlCampaign }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const localContext = useMemo(
    () => ({
      page: "chooseConnect",
      pageId,
    }),
    [pageId]
  );

  const bannerProps = useMemo(
    () => ({
      subtitle: ["Deliver locally and earn up to ", "£18 per hour"],
      title: ["Become a ", "DPD Connect", " driver"],
      boldIndex: 1,
      subtitleBoldIndex: 1,
      top: "title",
      banner: "banner4 banner-alternate",
      windowWidth,
      color: "blue",
      titleBreak: true,
    }),
    [windowWidth]
  );

  return (
    <Trackable
      loadId="chooseConnect"
      interfaceId="chooseConnectInterface"
      context={localContext}
    >
      <div className="choose-connect">
        <div className="hero-section">
          <Header active="chooseConnect" urlCampaign={urlCampaign} color="tertiary" />
          <Banner {...bannerProps} />
        </div>

        <TopContent variant="index" title="Why become a Connect driver?" description="You can earn up to £18 per hour, get paid weekly and use your own vehicle! You'll pick up all your parcels from a local collection point and you'll be delivering in your local area." />

        <HexagonContent
          imageAlignment="left"
          image={driver4}
          header={CONNECT_DRIVER_CONTENT.header}
          boldIndex={CONNECT_DRIVER_CONTENT.boldIndex}
          list={CONNECT_DRIVER_CONTENT.list}
          urlCampaign={urlCampaign}
          color="tertiary"
        />

        <VideoForceWatch urlCampaign={urlCampaign} {...VIDEO_SECTIONS.connect} />

        <FloatingButton urlCampaign={urlCampaign} href={routes.APPLY} color="tertiary" />
      </div>
    </Trackable>
  );
};

ChooseConnect.propTypes = {
  pageId: PropTypes.string.isRequired,
  windowWidth: PropTypes.number.isRequired,
  urlCampaign: PropTypes.string,
};

ChooseConnect.defaultProps = {
  urlCampaign: "",
};

export default ChooseConnect;
